import Accordion from "./Accordion";
import Splide from '@splidejs/splide';

export default class StatAccordion extends Accordion {
  constructor(elem) {
    super(elem);
    this.statSplideTickers = this.elem.querySelectorAll(".js-splide-stat");
    this.descriptionSplideTickers = this.elem.querySelectorAll(".js-splide-description");
    this.splideStatTickerInstances = [];
    this.splideDescriptionTickerInstances = [];
    this.pauseButtons = this.elem.querySelectorAll(".js-pause-button");

    this.flags = {
      ...this.flags,
      disableClickOutside: true,
      prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    }

    this.splideConfig = {
      direction: 'ttb',
      autoWidth: true,
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: false,
      interval: 3000,
      type: 'loop',
      speed: 300,
      easing: 'ease-in-out',
      drag: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    }

    this.splideDescriptionConfig = {
      ...this.splideConfig,
      height: 'var(--description-line-height, 24px)',
    }

    this.splideStatConfig = {
      ...this.splideConfig,
      height: 'var(--stat-line-height, 96px)',
    }
  }
  
  setupSplideTickers() {
    this.statSplideTickers.forEach(splide => {
      const splideInstance = new Splide(splide, this.splideStatConfig);
      this.splideStatTickerInstances.push({
        instance: splideInstance,
        isPaused: true,
      });

      splideInstance.mount();
    });

    this.descriptionSplideTickers.forEach(splide => {
      const splideInstance = new Splide(splide, this.splideDescriptionConfig);
      this.splideDescriptionTickerInstances.push({
        instance: splideInstance,
        isPaused: true,
      });

      splideInstance.mount();
    });
  }
  

  toggleAllPanels(index) {
    super.toggleAllPanels(index);
    
    // Handle ticker state for all panels
    this.panels.forEach((panel, i) => {
      const isExpanded = panel.classList.contains("expanded");
      // If user prefers reduced motion, keep tickers paused regardless of panel state
      const shouldPause = this.flags.prefersReducedMotion ? true : !isExpanded;
      this.setTickerState(i, shouldPause);
    });
  }

  setTickerState(index, isPaused) {
    const statSplideInstance = this.splideStatTickerInstances[index]?.instance;
    const descriptionSplideInstance = this.splideDescriptionTickerInstances[index]?.instance;

    if (!statSplideInstance || !descriptionSplideInstance) return;

    // Update internal state
    this.splideStatTickerInstances[index].isPaused = isPaused;
    this.splideDescriptionTickerInstances[index].isPaused = isPaused;

    // Update pause button attributes if it exists
    if (this.pauseButtons[index]) {
      this.pauseButtons[index].setAttribute("data-paused", isPaused.toString());
      this.pauseButtons[index].setAttribute("aria-label", isPaused ? "Play Sliders" : "Pause Sliders");
    }

    // Control the splide instances
    if (isPaused) {
      statSplideInstance.Components.Autoplay.pause();
      descriptionSplideInstance.Components.Autoplay.pause();
    } else {
      statSplideInstance.Components.Autoplay.play();
      descriptionSplideInstance.Components.Autoplay.play();
    }
  }

  handlePauseButtonClick(index) {
    const currentPausedState = this.splideStatTickerInstances[index]?.isPaused;
    if (currentPausedState === undefined) return;

    const newPausedState = !currentPausedState;
    this.setTickerState(index, newPausedState);
  }

  init() {    
    super.init();
    this.setupSplideTickers();

    this.pauseButtons.forEach((button, index) => {
      button.addEventListener("click", this.handlePauseButtonClick.bind(this, index));
    });
  }
}